import React, { createContext, FC, ReactNode, useContext } from 'react'
import { useOnboardingWizard } from 'apps/fleet-planner/hooks'

export const OnboardingWizardContext = createContext<ReturnType<typeof useOnboardingWizard>>({
  userEmail: undefined,
  activeStep: 0,
  carriers: [],
  selectedOptions: [],
  setUserEmail: () => {},
  setActiveStep: () => {},
  removeCarrierByIndex: () => {},
  addCarrier: () => {},
  setSelectedOptions: () => {},
  mobileApp: false,
})

export interface IOnboardingWizardProviderProps {
  children: ReactNode
}

export const OnboardingWizardProvider: FC<IOnboardingWizardProviderProps> = ({ children }) => {
  const state = useOnboardingWizard()
  return (
    <OnboardingWizardContext.Provider value={state}>{children}</OnboardingWizardContext.Provider>
  )
}

// Helper hook
export const useOnboardingWizardContext = () => useContext(OnboardingWizardContext)
